module.exports = __webpack_public_path__ + "static/media/DOUBLE BREASTED 4 BUTTONS.8b9c7b1a.svg";